import {
  TenantContext,
  TenantContextAction,
  UPDATE_TENANT_DATA,
  UPDATE_USERS_LIST,
  UsersMap,
} from "store/types/tenant-context.types";
import { GlobalState } from "store/configure-store";
import { TenantData } from "model/tenant-data.model";

export interface TenantContextState {
  users: UsersMap;
  tenantData: TenantData;
}

export const initialTenantContextState = {
  users: {},
  tenantData: { showTimeline: false, showMedication: false },
};

/** ---- SELECTORS ---- */
export const selectUserMap = (state: GlobalState): UsersMap => {
  return state.tenantContext.users;
};

/** ---- ACTION HANDLERS ---- */
const updateUsersList = (state: TenantContextState, users: UsersMap) => {
  return {
    ...state,
    users: { ...state.users, ...users },
    tenantData: { ...state.tenantData },
  };
};

const updateTenantData = (
  state: TenantContextState,
  tenantData: TenantData
) => {
  return {
    ...state,
    users: { ...state.users },
    tenantData: { ...state.tenantData, ...tenantData },
  };
};

/** ---- REDUCER ---- */
export const tenantContextReducer = (
  state = initialTenantContextState,
  action: TenantContextAction
): TenantContext => {
  switch (action.type) {
    case UPDATE_USERS_LIST:
      return updateUsersList(state, action.payload);
    case UPDATE_TENANT_DATA:
      return updateTenantData(state, action.payload);
    default:
      return state;
  }
};
